import api from '../utils/api';
export const getMaterialInventory = () => api.get('/api/materials/inventory');
export const getMaterialRolls = params => api.get('/api/materials/rolls', { params });
export const receiveMaterialRoll = data => api.post('/api/materials/rolls/receive', data);
export const adjustMaterialRoll = (id, data) => api.post(`/api/materials/rolls/${id}/adjust`, data);
export const getMaterialMovements = params => api.get('/api/materials/movements', { params });
export const getProductRecipe = id => api.get(`/api/materials/recipes/${id}`);
export const saveProductRecipe = (id, data) => api.put(`/api/materials/recipes/${id}`, data);
export const previewMaterialLayout = data => api.post('/api/materials/layout/preview', data);
export const confirmReceiptProduction = (id, data = {}) => api.post(`/api/materials/receipts/${id}/confirm-production`, data);
export const cancelReceiptProduction = (id, reason) => api.post(`/api/materials/receipts/${id}/cancel-production`, { reason });
export const getSignProfitReport = params => api.get('/api/materials/profit-report', { params });
